<div class="media" *ngIf="useIcon">
    <ng-content class="media-object" select="fui-icon"></ng-content>
</div>
<div class="modal" *ngIf="useIcon && title">
    <div class="modal-window">
        <div class="modal-window-content" id="action-label">
            {{title | translate}}
        </div>
    </div>
</div>
<div class="label" *ngIf="!useIcon">
    <div class="label-title">
        {{title | translate}}
    </div>
</div>
